
import React from 'react';
import PropTypes from 'prop-types';
import Button from 'common/components/elements/buttons/primary';

import { getSiteTitle } from 'common/utils/helper';
import Link from 'common/components/modules/link';

const MMSPAgeContact = ({
   siteName = 'Site name',
   isNextApp = false,
}) => {
   return (
      <div className='flex flex-col items-center w-full gap-8'>
         <div className='flex gap-6 flex-col items-center w-full text-center'>
            <span className='text-major dark:text-major-dark text-4xl leading-[44px]'>Contact us</span>
            <span className='text-major dark:text-major-dark text-xl leading-[30px]'>
               To contact <span dangerouslySetInnerHTML={ { __html: getSiteTitle() } } /> for member support or other inquiries, click the button below.
            </span>
         </div>
         <div className='inline-flex h-11'>
            <Button
               primaryColor
               text={ `Contact ${ getSiteTitle() }` }
               borderRadius='large'
               textSize='base'
               classNames='h-full px-4'
               padding='none'
               // onClick={ () =>  intercomMoreInfo(MEMBER_SUPPORT) }
               fontWeight='medium'
            />
         </div>
         <span className='text-major dark:text-major-dark text-xl leading-[30px] text-center'>
            To contact {siteName}, use the
            <Link
               isNextApp={ isNextApp }
               target='blank'
               href='/contact-form'
               className='contact-form-link skin-primary-text ml-1'
            >
               Contact form
            </Link>.
         </span>
      </div>

   );
}
MMSPAgeContact.propTypes = {
   isNextApp: PropTypes.bool,
   siteName: PropTypes.string,
};
MMSPAgeContact.defaultProps = {
}
export default MMSPAgeContact;


